// extracted by mini-css-extract-plugin
export default {"back_to_user":"style_back_to_user__mv6pP"};